import Labeled from 'admin/components/atoms/Labeled';
import { randomAlphanumeric } from 'admin/utils';
import React from 'react';
import DateTimePicker from 'react-datetime';
import styled, { StyledComponentPropsWithRef } from 'styled-components';

type LabledProps = StyledComponentPropsWithRef<typeof Labeled>;

type Props = {
  id?: string;
  labelText?: LabledProps['labelText'];
  className?: LabledProps['className'];
  labelPosition?: LabledProps['labelPosition'];
} & React.ComponentPropsWithoutRef<typeof DateTimePicker>;

const LabeledDateTimePicker = ({
  labelText = '',
  className = '',
  labelPosition = 'left',
  dateFormat = 'YYYY-MM-DD',
  timeFormat = 'HH:mm:ss',
  id,
  ...rest
}: Props) => {
  const iid = id || randomAlphanumeric(16);
  return (
    <Labeled
      labelText={labelText}
      className={className}
      labelPosition={labelPosition}
      htmlFor={iid}
    >
      <DateTimePicker key={iid} dateFormat={dateFormat} timeFormat={timeFormat} {...rest} />
    </Labeled>
  );
};

export default styled(LabeledDateTimePicker)`
  div.rdt {
    display: inline-block;
    width: 200px;
    margin-left: 5px;
  }
`;
